import { FC, useEffect } from 'react'

import { Notification as NotificationType } from 'models'
import { NotificationContainer } from './styled'
import { useDataContext } from 'context/data-context'
import { theme } from 'styles/theme'

export const Notification: FC<{ data: NotificationType }> = ({ data }) => {
  const { removeNotification } = useDataContext()

  useEffect(() => {
    const timeout = setTimeout(() => {
      removeNotification(data.id)
    }, 3000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <NotificationContainer
      initial={{
        opacity: 0,
        translateY: '2rem',
      }}
      animate={{
        opacity: 1,
        translateX: 0,
        translateY: 0,
        transition: {
          type: 'tween',
          duration: 0.5,
          ease: theme.easeValues.out,
        },
      }}
      exit={{
        opacity: 0,
        translateX: '-2rem',
        transition: {
          type: 'tween',
          duration: 0.3,
          ease: theme.easeValues.in,
        },
      }}
    >
      {data.text}
    </NotificationContainer>
  )
}
